import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

/**
 * Shown when an authenticated user navigates to a route their role cannot access.
 */
const Unauthorized: React.FC = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "#f8f9fa",
      }}
    >
      <div
        style={{
          maxWidth: "480px",
          width: "100%",
          background: "#fff",
          borderRadius: "8px",
          padding: "32px",
          boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
          textAlign: "center",
        }}
      >
        <h1 style={{ fontSize: "4rem", margin: "0 0 8px", color: "#dc3545" }}>403</h1>
        <h2 style={{ marginBottom: "12px" }}>Access Denied</h2>
        <p style={{ color: "#6c757d", marginBottom: "24px" }}>
          You do not have permission to view this page. Contact your administrator
          if you believe this is an error.
        </p>

        <div style={{ display: "flex", gap: "12px", justifyContent: "center", flexWrap: "wrap" }}>
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => navigate("/dashboard")}
          >
            Go to Dashboard
          </button>
          <button type="button" className="btn btn-outline-secondary" onClick={() => logout()}>
            Logout
          </button>
          <Link to="/login" className="btn btn-link">
            Switch account
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
